export default "__VITE_ASSET__Db6X9Zui__"